<template>
  <div class="dis dinline-block vtop br5 ofhidden mr15 mb20" @click="goPro(item.id)"><!---招生专业ITEM---->
    <img :src="item.image" width="375" height="240" />
    <div class="txt pl15 pr15 mt5">
      <div class="fs24 fbold tc6 lh12 mb5">{{item.name}}</div>
      <div class="tc9 fs14">{{item.short_description}}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "en-item",
  props:[
    'item',
  ],
  methods:{
    goPro(id){
      let path = `/cedu/professional/detail?id=${id}` 
      let routeData = this.$router.resolve({
          path
      })
      window.open(routeData.href, '_blank')
      //this.$router.push({path:'/cedu/professional/detail',query:{id:id}})
    },
  },
}
</script>

<style scoped>
  .zcdetail .dis{width: 375px;height: 330px;box-shadow: 0 0 3px #ccc;}
</style>



// WEBPACK FOOTER //
// src/components/cedu/school/en-item.vue